<template>
  <div class="template-detail-layout">
    <div class="template-detail-layout__heading">
      <slot name="option-heading" />
    </div>
    <div class="template-detail-layout__content">
      <slot name="option-content" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TemplateDetailLayout',
}
</script>

<style scoped>
.template-detail-layout {
  display: flex;
  flex-direction: column;
  row-gap: 30px;
}

.template-detail-layout__heading .app-heading {
  font-weight: 800;
  color: var(--c-magenta-500);
  letter-spacing: 0.5px;
}
</style>
